module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "em-wrap"
  }, [_c('modal', {
    staticClass: "em-modal",
    attrs: {
      "name": "email",
      "adaptive": true,
      "height": "auto",
      "width": "90%",
      "maxWidth": 560
    },
    on: {
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "em-dialog"
  }, [_c('div', {
    staticClass: "em-dialog-header"
  }, [_c('div', {
    staticClass: "em-dialog-header-left"
  }, [_c('span', {
    staticClass: "em-dialog-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 4h16v16H4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22 6l-10 7L2 6"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "em-dialog-title"
  }, [_vm._v("Edit Email")]), _vm._v(" "), _c('p', {
    staticClass: "em-dialog-sub"
  }, [_vm._v(_vm._s(_vm.runner.runner && _vm.runner.runner.user ? _vm.runner.runner.user.email : 'No email set'))])])]), _vm._v(" "), _c('button', {
    staticClass: "em-close-btn",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('email')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "em-dialog-body"
  }, [_c('label', {
    staticClass: "em-field"
  }, [_c('span', {
    staticClass: "em-label"
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newemail),
      expression: "newemail"
    }],
    staticClass: "em-input",
    attrs: {
      "type": "text",
      "maxlength": "255",
      "name": "newemail",
      "placeholder": "runner@example.com"
    },
    domProps: {
      "value": (_vm.newemail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newemail = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "em-dialog-footer"
  }, [_c('button', {
    staticClass: "em-cancel-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('email')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "em-save-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.Save(_vm.newemail)
      }
    }
  }, [_vm._v("Save")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bef3890e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/EditEmail.vue
// module id = 1752
// module chunks = 2